export const formatDateTime = (datetime) => {
  if (!datetime) return "";

  if (datetime.includes("T") || datetime.includes("Z")) {
    datetime = datetime.replace("T", " ").slice(0, 19);
  }

  return new Date(datetime).toLocaleString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatMonthlyData = (monthlyData) => {
  // Create an array for all 12 months with 0 as default value
  const allMonths = Array.from({ length: 12 }, (_, index) => ({
    month: index + 1,
    total: "0.00",
  }));

  // Fill in the actual values where we have data
  monthlyData.forEach((item) => {
    allMonths[item.month - 1] = {
      month: item.month,
      total: item.total,
    };
  });

  return allMonths;
};

export const statusText = (status) => {
  switch (status) {
    case "pending":
      return "Non payé";
    case "paid":
      return "Payée";
    case "canceled":
      return "Annulée";
    case "blocked":
      return "Bloquée";
    default:
      return status;
  }
};

export const statusTextWarning = (status) => {
  switch (status) {
    case "pending":
      return "En attente";
    case "finalized":
      return "Infraction confirmée";
    case "canceled":
      return "Annulée";
    default:
      return status;
  }
};

export const statusTextSubscription = (status) => {
  switch (status) {
    case "pending":
      return "En attente";
    case "active":
      return "Actif";
    case "approved":
      return "Approuvé";
    case "rejected":
      return "Rejeté";
    case "canceled":
      return "Résilié";
    case "expired_pending":
      return "Expiré en attente";
    default:
      return status;
  }
};

export const colorStatusInfraction = {
  pending: "warning", // orange
  paid: "success", // green
  canceled: "error", // red
  blocked: "volcano", // dark orange
};

export const colorStatusWarning = {
  pending: "warning", // orange
  finalized: "success", // green
  canceled: "error", // red
};

export function formatAmountInFrench(amount) {
  const formatter = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "MAD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(amount);
}

export const CLIENT_TYPES = {
  individuals: "Particuliers",
  companies: "Sociétés",
  institutions: "Organismes publics",
};

const CIVILITY_LABELS = {
  Mr: "Monsieur",
  Mme: "Madame",
  Mlle: "Mademoiselle",
};

export function getClientCivilityLabel(client) {
  if (!client) return "—";
  if (client.type === "companies" || client.type === "institutions") {
    return "Société";
  }
  return CIVILITY_LABELS[client.civility] || client.civility || "—";
}

export function getClientCinOrIce(client) {
  return client?.cin || client?.ice || "—";
}

export const CLIENT_TYPES_COLORS = {
  individuals: "blue",
  institutions: "green",
  companies: "purple",
};

export const SUBSCRIPTION_STATUS = {
  pending: "En attente",
  active: "Actif",
  rejected: "Rejeté",
  suspended: "Suspendu",
  canceled: "Résilié",
};

export const LOCATION_TYPES = {
  zone: "Contrat",
  section: "Zone",
  street: "Rue",
  line: "Ligne",
  global: "Global",
};

export const PAYMENT_DETAIL_TYPES = {
  registration_fee: "Frais d'inscription",
  echeance: "Paiement d'échéance",
  reactivation_fee: "Frais de réactivation",
  macaron_fee: "Frais de changement de macaron",
};

export const SETTINGS_FR = {
  registration_fee: "Frais d'inscription",
  time_between_warning_and_infraction:
    "Délai entre avertissement et infraction",
  max_distance_between_street_and_user: "Distance max entre rue et utilisateur",
  reliquat_start_day: "Jour de début du reliquat",
  reactivation_fee: "Frais de réactivation",
};

export const getClientDisplayName = (client) => {
  if (!client) return "N/A";

  if (client.type === "individuals") {
    return `${client.first_name || ""} ${client.last_name || ""}`.trim();
  } else if (client.type === "companies") {
    return client.name || "N/A";
  } else if (client.type === "institutions") {
    return client.name || "N/A";
  }
  return client.name || "N/A";
};

export const SOURCE_TYPES = {
  citizen_web: "Web citoyen",
  citizen_mobile: "Mobile citoyen",
  agent: "Agent",
};